export default __webpack_public_path__ + "static/media/nintendo-switch.8aa8e498.svg";